import { ChatbotWidget } from 'core/chatbot';
import PropTypes from 'prop-types';
import React from 'react';
import { useAIChat } from './useAIChat';

/**
 * App-level AI chat host: mounts the chat provider tree for every route (context stays
 * available for hooks) and the floating student UI where the tenant config allows it.
 */

type AIChatProps = {
  children: React.ReactNode;
};

function AIChat({ children }: AIChatProps): JSX.Element {
  const {
    chatService,
    className,
    getChatContextData,
    initialChatbotState,
    isAiEnabled,
    shouldHideChatbotUI,
    shouldRenderOnCurrentRoute,
  } = useAIChat();

  // Excluded routes get NO chatbot infrastructure — early return before the wrapper so auth
  // flips on these routes (e.g. /logout) can't remount the route subtree.
  if (!shouldRenderOnCurrentRoute) {
    return <>{children}</>;
  }

  return (
    <ChatbotWidget
      animationDuration={500}
      buttonIconName="chat"
      chatService={chatService}
      className={className}
      focusOnOpen={true}
      getChatContextData={getChatContextData}
      hideFloatingButton={shouldHideChatbotUI}
      initialState={initialChatbotState}
      isAIEnabled={isAiEnabled}
    >
      {children}
    </ChatbotWidget>
  );
}

AIChat.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AIChat;
